import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { DynamicComponent, InputLabel } from 'ui';
import { isNumber } from 'utils';

import s from './Input.module.scss';

const cx = cn.bind(s);

const Input = ({
  className,
  type,
  placeholder,
  label,
  disabled,
  error,
  variant,
  showErrorMessage,
  onChange,
  value,
  as,
  simpleBorderColor = false,
  inputTextCenter = false,
  ...attrs
}) => {
  const inputCombinedClassName = cx('input', {
    disabled,
    error,
    simpleBorderColor,
    brainable: variant === 'brainable',
    brainableSave: variant === 'brainableSave',
    number: type === 'number',
    inputTextCenter,
    textarea: as === 'textarea',
  });

  const handleChange = (ev) => {
    const { value: eventValue } = ev.target;
    if (type === 'number') {
      if (isNumber(eventValue)) {
        onChange(ev);
      }
    } else {
      onChange(ev);
    }
  };

  return (
    <InputLabel variant={variant} showErrorMessage={showErrorMessage} className={className}
      error={error}
      text={label}>
      <DynamicComponent
        tag={as}
        disabled={disabled}
        placeholder={placeholder}
        type={type}
        value={value}
        className={inputCombinedClassName}
        onChange={handleChange}
        {...attrs}
      />
    </InputLabel>
  );
};

Input.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['text', 'email', 'password', 'number', 'date', 'tel']),
  placeholder: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'brainable', 'brainableSave']),
  showErrorMessage: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  as: PropTypes.oneOf(['input', 'textarea']),
};

Input.defaultProps = {
  type: 'text',
  as: 'input',
  placeholder: '',
  variant: 'default',
  className: '',
  error: '',
  showErrorMessage: true,
  label: '',
  value: '',
  onChange: () => {
  },
  disabled: false,
};

export default Input;
